import Header from './components/Header.js';
import Carousel from './components/Carousel.js';
import Form from './components/Form.js';
import YouTube from './components/YouTube.js';
import Scrolly from './components/Scrolly.js';
import EyeSpreader from './components/EyeSpreader.js';
import RadarAnimation from './components/RadarAnimation.js';

export default class ComponentFactory {
  constructor() {
    this.componentList = {
      Header,
      Carousel,
      Form,
      YouTube,
      Scrolly,
      EyeSpreader,
      RadarAnimation,
    };
    this.init();
  }

  init() {
    // Crée les composantes selon l'attribut data-component
    const components = document.querySelectorAll('[data-component]');
    for (let i = 0; i < components.length; i++) {
      const element = components[i];
      const componentName = element.dataset.component;

      if (this.componentList[componentName]) {
        new this.componentList[componentName](element);
      } else console.log(`La composante ${componentName} n'existe pas!`);
    }
  }
}
